module.exports = __webpack_public_path__ + "img/illust-error.bd6d850a.svg";